import type { MenteeDashboardIdentity as MenteeIdentityData } from './MenteePortalService';
import { joinPresent } from '../mentorDashboardFormat';

type Props = {
    identity: MenteeIdentityData;
    cohortName: string | null;
    cohortStart: string | null;
    cohortEnd: string | null;
};

/** Hide absent fields entirely — never blank labels. */
const MenteeDashboardIdentity = ({ identity, cohortName, cohortStart, cohortEnd }: Props) => {
    const meta = joinPresent([
        identity.batchYear != null ? String(identity.batchYear) : null,
        identity.programName,
        identity.campusName,
    ]);
    const work = joinPresent([identity.designation, identity.company]);
    const cohortLine = joinPresent([
        cohortName,
        cohortStart && cohortEnd ? `${cohortStart} – ${cohortEnd}` : cohortStart || cohortEnd,
    ]);

    return (
        <div className="col-lg-8">
            <div className="small fw-medium text-white-75">Welcome to your mentorship journey,</div>
            {identity.name ? <h4 className="fw-bold mb-1">{identity.name}</h4> : null}
            {meta ? <div className="small text-white-75">{meta}</div> : null}
            {work ? <p className="mdash-meta">{work}</p> : null}
           
            {cohortLine ? (
                <div className='d-flex flex-wrap gap-2 mt-3'>
                    <span className="badge bg-white bg-opacity-20 border border-white border-opacity-25 py-2 px-3 rounded-pill fw-semibold text-primary-emphasis"><i className="bi bi-calendar"></i> {cohortLine}</span>
                </div>
            ) : null}
        </div>
    );
};

export default MenteeDashboardIdentity;
